import React from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";
import RequirementForm from "./requirementForm";
import RequirementEdit from "./requirementEditTable";
import AnchoredPortalModal from "../common/AnchoredPortalModal";

import "../menuStyle.css";

const buttonStyle = {
  // width: "80%",
  margin: "0.2rem 1rem",
  fontSize: "1.1rem",
};

const divStyle = {
  display: "flex",
  justifyContent: "center",   /* <- center; use flex-end for right-align */
  flexDirection: "column",
  gap: "8px",               /* space between buttons (Bootstrap 4: remove and add ml-2 on 2nd btn) */
  margin: "8px 0 12px",
};

class UpdateRequirement extends React.Component {
  state = { requirements: [], page: 0 };

  componentDidMount = () => {
    const requirements = this.props.requirements.reduce((all, item, i) => {
      item.template = item.template === 'any' ? 'Any' : this.props.templateMap[item.template] ? this.props.templateMap[item.template] : item.template;
      all.push(item);
      return all;
    }, []);
    this.setState({ requirements });
  }

  addRequirement = newReq => {
    this.setState({ requirements: newReq });
  };

  changePage = e => {
    const name = e.currentTarget?.name; 
    if (name === "addNew") {
      this.setState({ page: 1 });
    } else if (name === "edit") {
      this.setState({ page: 2 });
    } else {
      this.setState({ page: 0 });
    }
  };

  onClose = () => {
    const { page } = this.state;
    if (page === 0) {
      this.props.onCancel();
    } else {
      this.setState({ page: 0 });
    }
  };

  handleModalClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "clickaway") return;
    this.onClose();
  };

  onSubmit = () => {
    const { page } = this.state;
    if (page === 1) {
      this.props.onAddNew();
    }
  };

  renderFooter = () => {
    const { page } = this.state;
    const changeStarted = page === 1 || page === 2;
    const secondButton = changeStarted ? "Back" : "Cancel";
    return (
      <div className="updateReq__modal--buttons">
        {changeStarted && (
          <button
            className="updateReq__modal--button"
            variant="secondary"
            onClick={this.onSubmit}
          >
            Submit
          </button>
        )}
          <button
            className="edit-permission__modal--button"
            variant="secondary"
            onClick={this.onClose}
          >
            {secondButton}
          </button>
        </div>
    );
  }

  render = () => {
    const { page, requirements } = this.state;
    const { error } = this.props;
    const changeStarted = page === 1 || page === 2;
    const secondButton = changeStarted ? "Back" : "Cancel";
    return (
      // <Modal.Dialog dialogClassName="updateReq__modal">
      <AnchoredPortalModal
        open={true}
        onClose={this.handleModalClose}
        closeOnOutsideClick={false} 
        anchorEl={this.props.anchorEl}
        placement="bottom-start"
        title="Update Requirement"
        minWidth={360}
        backdrop={false}            // set true if you want dim behind
        showCloseButton={true}
        footer={this.renderFooter()}
        minusLeft={150}
      >
          {page === 0 && (
            <div style={divStyle} >
              <Button
                variant="light"
                name="addNew"
                style={buttonStyle}
                onClick={this.changePage}
                className="updateReq__btn"
              >
                Add New Requirement
              </Button>
              <Button
                variant="light"
                name="edit"
                style={buttonStyle}
                onClick={this.changePage}
                disabled={requirements.length === 0}
              >
                Delete Requirement
              </Button>
            </div>
          )}
          {page === 1 && (
            <>
              <RequirementForm
                requirements={requirements}
                onNewReqInfo={this.props.onNewReqInfo}
                templateMap={this.props.templateMap}
              />
              {error && <div className="err-message __field">{error}</div>}
            </>
          )}
          {page === 2 && (
            <RequirementEdit
              requirements={requirements}
              onDelete={this.props.onDelete}
            />
          )}
        </AnchoredPortalModal>
    );
  };
}

UpdateRequirement.propTypes = {
  onCancel: PropTypes.func,
  error: PropTypes.string,
  onAddNew: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onNewReqInfo: PropTypes.func,
  requirements: PropTypes.array,
  worklistID: PropTypes.string,

};

export default UpdateRequirement;
